import { render, staticRenderFns } from "./actividad-becarios-ars.vue?vue&type=template&id=797bb507&scoped=true&"
import script from "./actividad-becarios-ars.component.ts?vue&type=script&lang=ts&"
export * from "./actividad-becarios-ars.component.ts?vue&type=script&lang=ts&"
import style0 from "./actividad-becarios-ars.vue?vue&type=style&index=0&id=797bb507&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797bb507",
  null
  
)

export default component.exports